import { render, staticRenderFns } from "./ResponsavelDepartamento.vue?vue&type=template&id=2b97201e&"
import script from "./ResponsavelDepartamento.vue?vue&type=script&lang=js&"
export * from "./ResponsavelDepartamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports